<template>
  <footer class="ny-footer">
    <div class="flex-row centent">
      <div class="blank">
        <div class="item">
          <div>全国服务热线</div>
          <p>0771-555-5555</p>
        </div>
        <a href="javascript:;" class="item">
          <div class="flex-row">
            <div class="logo-icon">
              <img src="@/assets/email.png" alt="" />
            </div>
            <span class="logo-text">联系我们</span>
          </div>
          <p class="link-addss">nnnyhk@163.com</p></a
        >
      </div>
      <div class="blank">
        <div class="items">
          <div class="header">年盈旅行</div>
          <router-link :to="{ name: 'solution' }">
            <p>解决方案</p>
          </router-link>
          <!-- <router-link :to="{ name: 'conference' }">
            <p>红学</p>
          </router-link> -->
          <!-- <router-link :to="{ name: 'interface' }">
            <p>&nbsp;</p>
          </router-link> -->
        </div>
      </div>
      <div class="blank">
        <div class="items">
          <div class="header">关于我们</div>
          <router-link :to="{ name: 'aboutus' }">
            <p>公司简介</p>
          </router-link>
          <router-link :to="{ name: 'aboutus' }">
            <p>商务合作</p>
          </router-link>
          <router-link :to="{ name: 'joinus' }">
            <p>人才招聘</p>
          </router-link>
        </div>
      </div>
      <div class="blank" >
        <div class="wechat" >
          <div class="icon-box" >
            <div class="img" >
              <img
                src="@/assets/wechat.jpg"
                alt=""
                
              />
            </div>
            <p >年盈航空服务号</p>
            <div class="tab" >
              <ul class="flex-row flex-between" >
                <li >
                  <img src="@/assets/wechat.png" alt=""/>
                </li>
                <li >
                  <img src="@/assets/apple.png" alt=""/>
                </li>
                <li >
                  <img src="@/assets/android_round.png" alt=""/>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="slogan">企业差旅&nbsp;|&nbsp;{{createdYear}}年高品质服务商</div>
    <div class="flex-row flex-center info">
      <div class="logo">
        <img src="@/assets/logo.png" alt="" />
      </div>
      <div class="left">
        <p>公司名称: 南宁年盈航空客货服务有限责任公司</p>
        <p>公司地址: 广西南宁市五象大道399号龙光国际2号楼7层</p>
        <a target="_blank" href="https://beian.miit.gov.cn/">
          <p>Copyright© 桂ICP备12006418号</p></a
        >
      </div>
    </div>
  </footer>
</template>

<script>
import dayjs from "dayjs";
export default {
  name: "foot",
  props: {
    msg: String,
  },
  data() {
    return {
      createdYear: 0
    }
  },
  mounted(){
    let year = dayjs().diff('2000-07-05', 'year', true)
    this.createdYear = Math.floor(year)
  }
};
</script>
<style lang="less" scoped>
.ny-footer {
  width: 100%;
  background: #1e2430;
  padding: 70px 0 30px;
  .centent {
    width: 1040px;
    color: #fefefe;
    margin: 0 auto;
    justify-content: space-between;
    .icon-box {
      width: 180px;
      height: 200px;
      border: 1px solid #fff;
      .img {
        width: 100px;
        height: 100px;
        margin: 30px auto;
      }
      p{
        font-size: .9rem;
        line-height: 1.2em;
        margin-bottom: 13px;
        font-weight: 700;
        text-align: center;
      }
      .tab {
        width: 130px;
        height: 20px;
        margin: 0 auto;
        z-index: 9;
        background: #1e2430;
        ul{
          width: 80%;
          margin: 0 auto;
          li{
            cursor: pointer;
            width: 20px;
            height: 20px;
            border-radius: 50%;
          }
        }
      }
    }
    .blank {
      width:24%;
      .item {
        width: 100%;
        margin-bottom: 30px;
        div {
          font-size: 1rem;
          margin-bottom: 20px;
          font-weight: 700;
        }
        p {
          font-size: 1.4rem;
          line-height: 1.2em;
          margin-bottom: 10px;
          font-weight: 700;
          color: #f85148;
        }
      }
      a {
        color: #7e8c8d;
        text-decoration: none;
        width: 100%;
        margin-bottom: 30px;
        .logo-icon {
          width: 20px;
          margin-right: 10px;
          margin-bottom: 0 !important;
          img {
            width: 100%;
          }
        }
        .logo-text {
          color: #fff;
          font-weight: 700;
          font-size: 0.9rem;
          margin-bottom: 0 !important;
        }
        .link-addss {
          line-height: 1.2em;
          margin-bottom: 10px;
          font-weight: 700;
          color: #c8cec4;
          font-size: 0.9rem;
        }
      }
      .wechat {
        width: 100%;
        .centent {
          width: 180px;
          height: 200px;
          border: 1px solid #fff;
          .img {
            width: 100px;
            height: 100px;
            margin: 30px auto;
            img {
              width: 100%;
            }
          }
        }
      }
      .items {
        width: 100%;
        .header {
          font-size: 1rem;
          margin-bottom: 20px;
          font-weight: 700;
        }
        p {
          font-size: 0.8rem;
          line-height: 1.2em;
          margin-bottom: 10px;
          font-weight: 700;
          color: #ccc;
        }
        a {
          font-size: 0.9rem;
          line-height: 1.2em;
          margin-bottom: 10px;
          font-weight: 700;
          color: #c8cec4;
        }
      }
    }
  }
  .slogan {
    margin: 0 auto;
    padding: 10px 0 30px;
    border-bottom: 1px solid #575a5b;
    color: #fefefe;
    font-size: 0.9rem;
    font-weight: 700;
    text-align: center;
  }
  .info {
    margin: 0 auto;
    padding: 30px 20px 0;
    color: #c8cec4;
    text-align: center;
    .logo {
      width: 136px;
      height: 75px;
      background-size: 100% 100%;
      margin-right: 30px;
      img {
        width: 100%;
      }
    }
    .left {
      text-align: left;
      p {
        line-height: 1.2em;
        margin-bottom: 10px;
        font-size: 0.9rem;
        a {
          color: #c8cec4;
          display: inline-block;
        }
      }
      a {
        color: #7e8c8d;
        align-items: center;
        text-decoration: none;
        margin: 10px 0;
        display: flex;
        img {
          width: 20px;
          display: inline-block;
          -webkit-user-drag: none;
        }
        p {
          margin-left: 20px;
          color: #c8cec4;
          line-height: 1.2em;
          font-size: 0.9rem;
        }
      }
      .iso {
        font-size: 0.8rem;
        width: 235px;
        border: 1px solid #c8cec4;
        border-radius: 12px;
        margin-top: 10px;
        padding: 3px 5px;
        img {
          width: 10px;
          margin-right: 5px;
        }
        span {
          color: #c8cec4;
        }
      }
    }
  }
}
</style>
